<template>
    <div>
        <rkm-modal
            :title="title"
            extra-large
            ref="RkmModal"
        >
            <rkm-table
                :fields="fields"
                :items="items"
            />

            <template v-slot:footer="{cancel}">
                <rkm-button
                    :disabled="!!loading"
                    @click="cancel"
                    color="secondary"
                >
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({loading: 'getLoading'}),
        fields() {
            return [
                {key: 'unidadeNomeFantasia', label: 'Unidade'},
                {key: 'statusProcessamento', label: 'Status do processamento'},
                {key: 'codigoRegistro', label: 'Código do registro'},
                {key: 'materialDescricao', label: 'Material'},
                {key: 'fabricanteNome', label: 'Fabricante'},
                {key: 'lote', label: 'Lote'},
                {key: 'dataValidade', label: 'Data de validade do lote'},
                {key: 'quantidade', label: 'Quantidade'},
            ]
        },
    },
    created() {
        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.bnafar.gerenciamentoEnvio')
        }
    },
    data: () => ({
        items: [],
        title: 'Itens enviados',
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.items = []

            if (item.protocolo) {
                this.title = `Protocolo ${item.protocolo} - ${item.servicoTipoDescricao} - Itens enviados`
            } else {
                this.title = `${item.servicoTipoDescricao} - Itens enviados`
            }

            this.load(item)
            this.$refs.RkmModal.show()
        },
        load(item) {
            this.setLoading()

            this.repositories.gerenciamentoEnvio.show(item.id)
                .then(response => this.items = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository, stringCase],
}
</script>